import { useCallback, useEffect, useState } from "react";
import {
  clearProjectAssistMetadataCache,
  getProjectAssistMetadata
} from "../../../Services/productionMetadata";

export function useProjectAssistMetadata(enabled) {
  const [specializations, setSpecializations] = useState([]);
  const [contentTypes, setContentTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = useCallback(
    async ({ forceRefresh = false } = {}) => {
      if (!enabled) {
        setSpecializations([]);
        setContentTypes([]);
        setError(null);
        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        const data = await getProjectAssistMetadata({ forceRefresh });
        setSpecializations(
          Array.isArray(data?.specializations) ? data.specializations : []
        );
        setContentTypes(
          Array.isArray(data?.contentTypes) ? data.contentTypes : []
        );
        setError(null);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    },
    [enabled]
  );

  useEffect(() => {
    load();
  }, [load]);

  const refresh = useCallback(() => {
    clearProjectAssistMetadataCache();
    return load({ forceRefresh: true });
  }, [load]);

  return {
    specializations,
    contentTypes,
    loading,
    error,
    refresh
  };
}
